"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { ErrorBoundary } from "../ErrorBoundary.js";
import { Footer, FallbackFooter } from "../Footer/Footer.js";
import { Header, FallbackHeader } from "../Header/Header.js";
import styles from "./Layout.module.scss.js";
function LayoutInner(props) {
  var _a, _b;
  const root = useRef(null);
  const banner = useRef(null);
  useEffect(() => {
    var _a2;
    if (!props.banner || !banner.current) {
      return (_a2 = root.current) == null ? void 0 : _a2.style.setProperty("--zapier-banner-height", "0px");
    }
    const resizeObserver = new ResizeObserver(() => {
      var _a3, _b2;
      (_b2 = root.current) == null ? void 0 : _b2.style.setProperty(
        "--zapier-banner-height",
        `${((_a3 = banner.current) == null ? void 0 : _a3.clientHeight) ?? 0}px`
      );
    });
    resizeObserver.observe(banner.current);
    return () => resizeObserver.disconnect();
  }, [props.banner]);
  return /* @__PURE__ */ jsxs("div", { className: styles.root, ref: root, children: [
    props.banner && /* @__PURE__ */ jsx("div", { className: styles.banner, ref: banner, children: props.banner }),
    !props.hideHeader && /* @__PURE__ */ jsx(
      Header,
      {
        accounts: props.accounts,
        baseURL: props.baseURL,
        currentPath: props.currentPath,
        data: (_a = props.data) == null ? void 0 : _a.header,
        dataBaseURL: props.dataBaseURL,
        disableDataFetching: props.disableHeaderDataFetching,
        mainID: props.mainID,
        session: props.session,
        staging: props.staging
      }
    ),
    /* @__PURE__ */ jsx("main", { className: styles.main, id: props.mainID ?? "main", children: props.children }),
    !props.hideFooter && /* @__PURE__ */ jsx(
      Footer,
      {
        baseURL: props.baseURL,
        currentPath: props.currentPath,
        data: (_b = props.data) == null ? void 0 : _b.footer,
        dataBaseURL: props.dataBaseURL,
        disableDataFetching: props.disableFooterDataFetching,
        showAlphabetNav: props.showAlphabetNav,
        showSEOLinks: props.showSEOLinks,
        staging: props.staging
      }
    )
  ] });
}
function FallbackLayout(props) {
  return /* @__PURE__ */ jsxs("div", { className: styles.root, children: [
    /* @__PURE__ */ jsx(FallbackHeader, {}),
    /* @__PURE__ */ jsx("main", { className: styles.main, id: "main", children: props.children }),
    /* @__PURE__ */ jsx(FallbackFooter, {})
  ] });
}
function Layout(props) {
  return /* @__PURE__ */ jsx(
    ErrorBoundary,
    {
      name: "Layout",
      renderFallback: () => /* @__PURE__ */ jsx(FallbackLayout, { children: props.children }),
      children: /* @__PURE__ */ jsx(LayoutInner, { ...props })
    }
  );
}
export {
  Layout
};
